import Vue from 'vue';
import router from '@/router';
import axios from 'axios';
import store from '@/store';

axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['Content-Type'] = 'application/json';

axios.interceptors.request.use(
    (config) => {
      return config;
    },
    (error) => {
      return Promise.reject(error);
    },
);

axios.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {

      const originalConfig = error.config;

      if (!originalConfig.url.includes('auth') && error.response && error.response.status === 401
          && Vue.$cookies.get('refreshToken') && !originalConfig._retry) {
        originalConfig._retry = true;

        try {
          const result = await axios.post('/v2/auth/reissue-token', {
            refreshToken: Vue.$cookies.get('refreshToken'),
          });

          const newAccessToken = result.data.data.tokenInfo.accessToken;
          const refreshToken = result.data.data.tokenInfo.refreshToken;

          store.set('app/accessToken', newAccessToken);
          store.set('app/refreshToken', refreshToken);
          Vue.$cookies.set('accessToken', newAccessToken, '1h');
          Vue.$cookies.set('refreshToken', refreshToken, '3h');

          axios.defaults.headers.common['Authorization'] = `Bearer ${newAccessToken}`;
          originalConfig.headers['Authorization'] = `Bearer ${newAccessToken}`;

          return axios(originalConfig);
        } catch (_error) {
          Vue.$cookies.keys().forEach(cookie => Vue.$cookies.remove(cookie));
          axios.defaults.headers.common['Authorization'] = null;

          return router.push({
            name: 'login',
            query: {redirect: router.currentRoute.fullPath},
          });
        }
      } else if (error.response && error.response.status === 401 && router.currentRoute.name !== 'login') {
        let redirect = router.currentRoute.fullPath;

        return await router.push({
          name: 'login',
          query: { redirect: redirect },
        });
      }

      return Promise.reject(error);
    },
);

Vue.prototype.$axios = axios;